"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("@styled-system/prop-types"));

var _propTypes2 = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _base = _interopRequireDefault(require("../../style/themes/base"));

var _color = _interopRequireDefault(require("../../style/utils/color"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Box = _styledComponents.default.div`
  ${_styledSystem.space}
  ${_styledSystem.layout}
  ${_styledSystem.flexbox}
  ${_color.default}

  ${({
  overflowWrap
}) => overflowWrap && (0, _styledComponents.css)`
      overflow-wrap: ${overflowWrap};
    `}

  ${({
  scrollVariant,
  theme
}) => scrollVariant && (0, _styledComponents.css)`
      scrollbar-color: ${theme.scrollbar[scrollVariant].thumb}
        ${theme.scrollbar[scrollVariant].track};

      &::-webkit-scrollbar {
        width: 8px;
      }
      &::-webkit-scrollbar-track {
        background-color: ${theme.scrollbar[scrollVariant].track};
      }
      &::-webkit-scrollbar-thumb {
        background-color: ${theme.scrollbar[scrollVariant].thumb};
      }
    `}
`;
Box.propTypes = {
  /** Styled system box props */
  ..._propTypes.default.space,

  /** Styled system flex props */
  ..._propTypes.default.flexbox,

  /** Styled system layout props */
  ..._propTypes.default.layout,

  /** Styled system color props */
  ..._propTypes.default.color,

  /** String to set Box content break strategy. Note "anywhere" is not supported in Safari and IE11 */
  overflowWrap: _propTypes2.default.oneOf(["break-word", "anywhere"]),

  /** scroll styling attribute */
  scrollVariant: _propTypes2.default.oneOf(["light", "dark"])
};
Box.defaultProps = {
  theme: _base.default
};
var _default = Box;
exports.default = _default;